import { render, staticRenderFns } from "./TipoImpressao.vue?vue&type=template&id=670df45a"
import script from "./TipoImpressao.vue?vue&type=script&lang=js"
export * from "./TipoImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports